import React, { useState } from "react";
import { FaFacebookF, FaGithub } from 'react-icons/fa';

import logo from './assets/logo.jpg';
import certified from './assets/certified.jpg';
import "./EarCareWebsite.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

function Card({ children, className }) {
  return <div className={`card ${className}`}>{children}</div>;
}

function CardContent({ children, className }) {
  return <div className={`card-content ${className}`}>{children}</div>;
}

function Button({ children, onClick, className }) {
  return (
    <button onClick={onClick} className={`button ${className}`}>
      {children}
    </button>
  );
}

function Dialog({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="dialog-overlay">
      <div className="dialog-box">
        <button className="dialog-close" onClick={onClose}>
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}

function DialogHeader({ children }) {
  return <div className="dialog-header">{children}</div>;
}

function DialogTitle({ children }) {
  return <h3 className="dialog-title">{children}</h3>;
}

export default function EarCareWebsite() {
  const [open, setOpen] = useState(false);
  const reviews = [
    {
      text: "Fantastic and honest service, I was advised that my ears were clear and didn’t need any treatment. I would 100% recommend.",
      author: "Linda Perry"
    },
    {
      text: "I was having trouble hearing I came to visit Faith who looked in my ears with her digital camera and found I was full of wax. I was very nervous Faith put me at ease and removed all the wax I would recommend Faith for comfortable ear wax removal.",
      author: "Debbie Harding"
    }
  ];

  return (
    <div className="site">
      {/* Title Section */}
      <section className="hero">
        <img src={logo} alt="EarCare Logo" className="icon" />
        <div className="hero-info">
          <h1>Are you suffering with ear ache, tinnitus, dizziness or hearing loss?</h1>
          <p>
            Ear wax may be the cause! <br />
            <strong>Southbourne Ear Care</strong> provides comfortable &amp; safe ear wax removal.
          </p>
          <p>
            Certified in microsuction, irrigation &amp; manual wax removal techniques. Fully insured.
          </p>
        </div>
      </section>

      <div className="arrow arrow-first"></div>
      <div className="arrow arrow-second"></div>

      {/* Services Section */}
      <section className="services">
        <h2>What We Offer</h2>
        <div className="services-grid">
          <Card>
            <CardContent>
              <img
                width="200"
                height="200"
                src="https://img.icons8.com/external-hidoc-kerismaker/200/external-Suction-dentist-hidoc-kerismaker.png"
                alt="Microsuction icon"
              />
              <h3>Microsuction</h3>
              <p>
                Microsuction earwax removal is a gentle and effective way to clear blocked ears. 
                Using a tiny suction device, the wax is carefully removed from the ear canal to help restore comfort and clarity.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <img
                width="200"
                height="200"
                src="https://img.icons8.com/external-hidoc-kerismaker/200/external-Dropper-alternative-medicine-hidoc-kerismaker.png"
                alt="Irrigation icon"
              />
              <h3>Irrigation</h3>
              <p>
                Ear irrigation is a simple and effective way to clear excess earwax. 
                Using a gentle flow of water, the ear canal is flushed to help remove buildup and leave your ears feeling clean and refreshed.
              </p>
            </CardContent>
          </Card>
        </div>
        <p>Appointments are available Monday to Friday from 9am to 6pm.</p>
      </section>

      <hr className="divider" />

      {/* Prices Section */}
      <section className="prices">
        <h2>Prices</h2>
        <p>£20 for a consultation and complete ear health check.</p>
        <p>£55 for microsuction and/or irrigation (includes ear health check). If both treatments are required, the total is still £55.</p>
      </section>

      <hr className="divider" />

      {/* Before Appointment Section */}
      <section className="pre-appointment">
        <h2>Before Your Appointment</h2>
        <p>
          We recommend using olive oil drops &mdash; 3 drops a day for 3 days &mdash; to help soften the wax,
          making it easier and more comfortable to remove.
        </p>
        <p>Aftercare advice will be provided during your appointment.</p>
      </section>

      <hr className="divider" />

      {/* Reviews Section */}
      <section className="reviews">
        <h2>What Our Customers Say</h2>
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 10000 }}
          loop={true}
          className="reviews-carousel"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <blockquote>
                <p>"{review.text}"</p>
                <p className="review-author">- {review.author}</p>
              </blockquote>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* Booking Section */}
      <section className="appointment">
        <div className="custom-shape-divider-top-1">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              className="shape-fill"
            ></path>
          </svg>
        </div>
        <h2>Ready To Book?</h2>
        <Button onClick={() => setOpen(true)}>How to get in touch</Button>
      </section>

      {/* Appointment Popup */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogHeader>
          <DialogTitle>Booking an Appointment</DialogTitle>
        </DialogHeader>
        <div className="dialog-content">
          <p>
            To arrange an appointment, please contact Faith on:
            <span className="highlight"> 07810 826280</span>
          </p>
          <p>
            Once an appointment has been confirmed, please download and complete the consent form below and bring it with you.
          </p>
          <a href={`${process.env.PUBLIC_URL}/SEC Consent Form.pdf`} download className="download-btn">
            ⬇ Download Form
          </a>
        </div>
      </Dialog>

      {/* Footer Section */}
      <footer>
        <div className="custom-shape-divider-top-2">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              className="shape-fill"
            ></path>
          </svg>
        </div>
        <div className="footer-content">
          <p>
            <img src={certified} alt="Certified" />
          </p>
          <p>&copy; {new Date().getFullYear()} Southbourne Ear Care. All rights reserved.</p>
          <p>
            <a href="mailto:info@southbourneearcare.co.uk">
              info@southbourneearcare.co.uk
            </a>{" "}
            | 07810 826280
          </p>
          <p className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61576464923770"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://github.com/oliverwhittle"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FaGithub />
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
